import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const BotswanaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14407'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14407)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#8BBDEA'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#8BBDEA'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33329H20V4.66663H0V9.33329Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 8.39998H20V5.59998H0V8.39998Z'
					fill='#262626'
				/>
			</g>
		</svg>
	);
};

export default BotswanaFlagIcon;
